import { render, staticRenderFns } from "./vsNavGroup.vue?vue&type=template&id=0d5d2ff9"
import script from "./vsNavGroup.vue?vue&type=script&lang=js"
export * from "./vsNavGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports